import { AxiosPromise } from 'axios';

import API_URLS from '@Constants/apiUrls.constants';
import {
  PrintAndExportCallLogPayload,
  PrintAndExportSessionSummaryPayload,
} from '@Models/report.model';
import query from '@Utils/common/query.utils';

import axiosInstance from './axiosInstance.service';

export default {
  printCallLogReport: (
    callLogQuery: PrintAndExportCallLogPayload
  ): AxiosPromise =>
    axiosInstance({
      method: 'POST',
      url: `${API_URLS.REPORT.PRINT_CALL_LOG}?${query.stringify({
        ...callLogQuery,
      })}`,
      responseType: 'arraybuffer',
    }),
  printSessionSummary: (
    sessionSummaryQuery: PrintAndExportCallLogPayload
  ): AxiosPromise =>
    axiosInstance({
      method: 'POST',
      url: `${API_URLS.REPORT.PRINT_SESSION_SUMMARY}?${query.stringify({
        ...sessionSummaryQuery,
      })}`,
      responseType: 'arraybuffer',
    }),
  exportCallLogReport: (
    callLogQuery: PrintAndExportCallLogPayload
  ): AxiosPromise =>
    axiosInstance({
      method: 'POST',
      url: `${API_URLS.REPORT.EXPORT_CALL_LOG}?${query.stringify({
        ...callLogQuery,
      })}`,
    }),
  exportSessionSummaryReport: (
    sessionSummaryQuery: PrintAndExportSessionSummaryPayload
  ): AxiosPromise =>
    axiosInstance({
      method: 'POST',
      url: `${API_URLS.REPORT.EXPORT_SESSION_SUMMARY}?${query.stringify({
        ...sessionSummaryQuery,
      })}`,
    }),
};
